$.validator.addMethod('monthRule', function(value, element) {
    return this.optional(element) || /^(01|02|03|04|05|06|07|08|09|10|11|12)$/.test(value);
}, 'Please enter valid month number');

$.validator.addMethod('phoneLite', function(value, element) {
    let chars = '_';
    let charsFlag = true;
    for (let char of chars.split('')) {
        if (value.indexOf(char) > -1) {
            charsFlag = false;
        }
    }
    return this.optional(element) || charsFlag;
}, 'Please enter valid phone number');

$.validator.addMethod('zipLite', function(value, element) {
    let chars = '_';
    let charsFlag = true;
    for (let char of chars.split('')) {
        if (value.indexOf(char) > -1) {
            charsFlag = false;
        }
    }
    return this.optional(element) || charsFlag;
}, 'Please enter valid zip code');

$.validator.methods.email = function(value, element) {
    return this.optional(element) || /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/.test(value);
}

$.validator.addMethod('cpf', function (value,element) {
    var pattern = /^([\d]+[\d]+[\d]+[\.]+[\d]+[\d]+[\d]+[\.]+[\d]+[\d]+[\d]+[\-]+[\d]+[\d])|([\d]+[\d]+[\.]+[\d]+[\d]+[\d]+[\.]+[\d]+[\d]+[\d]+[\/]+[\d]+[\d]+[\d]+[\d]+[\-]+[\d]+[\d])$/;
    var check =pattern.test( value );

    var success_cpfs = [
        '00003456789',
        '00003456790'
    ];

    var invalid_cpfs = [
        '00000000000',
        '11111111111',
        '22222222222',
        '33333333333',
        '44444444444',
        '55555555555',
        '66666666666',
        '77777777777',
        '88888888888',
        '99999999999',
        '00000000000000',
        '11111111111111',
        '22222222222222',
        '33333333333333',
        '44444444444444',
        '55555555555555',
        '66666666666666',
        '77777777777777',
        '88888888888888',
        '99999999999999'
    ];

    if(check){
        var cpf = value.replace(/[^\d]+/g,'');
        if($.inArray( cpf, success_cpfs)!=-1){
            return true;
        }

        if($.inArray( cpf, invalid_cpfs)!=-1){
            return false;
        }

        if (cpf.length != 11&&cpf.length != 14) {
            return false;
        }

        if (cpf.length == 11){
            var add = 0;
            for (var i=0; i < 9; i++){
                add += parseInt(cpf.charAt(i)) * (10 - i);
            }
            var rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)	{
                rev = 0;
            }
            if (rev != parseInt(cpf.charAt(9))){
                return false;
            }

            add = 0;
            for (i = 0; i < 10; i++){
                add += parseInt(cpf.charAt(i)) * (11 - i);
            }
            rev = 11 - (add % 11);
            if (rev == 10 || rev == 11){
                rev = 0;
            }
            if (rev != parseInt(cpf.charAt(10))){
                return false;
            }

            return true;
        }else{
            var length = cpf.length - 2;
            var nums = cpf.substring(0,length);
            var digits = cpf.substring(length);
            var sum = 0;
            var pos = length - 7;
            for (var i = length; i >= 1; i--) {
                sum += nums.charAt(length - i) * pos--;
                if (pos < 2){
                    pos = 9;
                }
            }
            var result = sum % 11 < 2 ? 0 : 11 - sum % 11;
            if (result != digits.charAt(0)){
                return false;
            }

            length = length + 1;
            nums = cpf.substring(0,length);
            sum = 0;
            pos = length - 7;
            for (var i = length; i >= 1; i--) {
                sum += nums.charAt(length - i) * pos--;
                if (pos < 2){
                    pos = 9;
                }
            }
            result = sum % 11 < 2 ? 0 : 11 - sum % 11;
            if (result != digits.charAt(1)){
                return false;
            }

            return true;
        }
    }else{
        return false;
    }
}, 'Please enter valid cpf/cnpj number');

$.validator.addMethod("lh_name", function(value, element) {
    if (/\d/.test(value)) {
        return false;
    }
    let chars = ',=~!@#$%^&*()_+<>?:"{}[];/|\\';

    for (let char of chars.split('')) {
        if (value.indexOf(char) > -1) {
            return false;
        }
    }
    return true;
});

$.validator.addMethod("zoho_email", function(value, element) {
    if (this.optional(element)) {
        return true;
    }
    value = value.trim();

    const regExp = /^[\+\-\p{L}\p{M}\p{N}_]([\p{L}\p{M}\p{N}!#$%&‘*+\-\/=?^_`{|}~.]*)@(?=.{4,256}$)(([\p{L}\p{N}\p{M}]+)(([\-_]*[\p{L}\p{M}\p{N}])*)[.])+[\p{L}\p{M}]{2,22}$/u;

    if (!regExp.test(value)) {
        return false;
    }
    const regRes = regExp.exec(value)

    if (regRes[1].length > 64) {
        return false;
    }
    let domain = value.split('@')[1];

    if (domain.length > 255) {
        return false;
    }

    return true;
});

$.validator.addMethod("exactZipLength", function(value, element, params) {
    try {
        let countryId = null;

        if ($(element).attr('data-event-id')) {
            countryId = $('[data-event-id="'+$(element).attr('data-event-id')+'"][data-name="country_id"]').val(); // split onetime page
        }
        if (!countryId) {
            countryId = $('select#countriesList:visible').val(); // subscription contact page
        }
        if (!countryId) {
            countryId = $('#address-country-id').data('country-id'); // subscription address page (3 step)
        }
        if (!countryId) {
            countryId = $('select[name="country_id"]:visible').val(); // profile update subscription modal
        }

        let selectedCountry = allCountries.find(function(country) {
            return country.id == countryId;
        });
        if (selectedCountry.code == 'US' && !params[selectedCountry.code].includes(value.replace(/\-/g, '').length)) {
            $.validator.messages.exactZipLength = 'Zip should be ' + params[selectedCountry.code].join(' or ') + ' numbers long';
            return false;
        }
        return true;
    } catch (e) {
        return true;
    }
});
